// extracted by mini-css-extract-plugin
module.exports = {"container":"NewAnimalPanel_container__1iQ7Y","containerLight":"NewAnimalPanel_containerLight__3R3Wn"};